<template>
    <v-card outlined :class="[{ 'red lighten-4': hasError }, small ? 'pa-1' : 'pa-3']" v-bind="$attrs"
        v-on="{ ...$on, ...$listeners }">
        <!-- Avatar and badge at the top -->
        <div class="d-flex justify-center py-1" :class="small ? 'mb-0' : 'mb-3'">
            <user-avatar :user="patrol" :size="small ? '24' : '48'" :badgeVisible="patrol.tasks.length > 0"
                :badgeColor="badgeColor" :badgeValue="patrol.tasks.length"></user-avatar>
        </div>

        <!-- Patrol name - hide in small mode -->
        <div v-if="!small" class="text-center mb-2">
            <div class="text-subtitle2 font-weight-medium">
                {{ patrol | userName }}
            </div>
        </div>

        <!-- Progress bar - hide in small mode -->
        <div v-if="!small && progress" class="mb-3">
            <v-progress-linear :value="stats ? progress : 0" height="8" color="primary" rounded></v-progress-linear>
            <div class="text-caption text-center mt-1">
                {{ progress }}%
            </div>
        </div>

        <!-- Status icon -->
        <div class="d-flex justify-center" :class="small ? 'mb-0' : 'mb-2'">
            <router-link v-if="task != null" class="text-decoration-none"
                :to="{ name: 'Event', params: { id: task.event.id } }">
                <task-status-icon v-if="task != null" :status="status" :stats="stats"
                    :size="small ? 'small' : 'default'"></task-status-icon>
            </router-link>
            <task-status-icon v-if="task == null" :status="free" :stats="stats"
                :size="small ? 'small' : 'default'"></task-status-icon>
        </div>

        <!-- Site info - hide in small mode -->
        <div v-if="task != null" class="text-center">
            <div class="text-caption font-weight-bold">
                {{ site | codeName }}
            </div>
            <div v-if="!small" class="text-caption">
                {{ site.name }}
            </div>
        </div>
    </v-card>
</template>

<script>
import { patrolCardMixin } from '@/composables/usePatrolCard'

export default {
  name: 'PatrolCardVertical',
  inheritAttrs: false,
  mixins: [patrolCardMixin],
  props: {
    patrol: {
      type: Object,
      required: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showMenu() {
      this.$emit('click', this.patrol)
    },
  },
  computed: {
    cardHeight() {
      return this.small ? '60px' : 'auto'
    }
  },
}
</script>

<style lang="sass" scoped>
.v-card
  cursor: pointer
  transition: all 0.3s ease
  min-height: v-bind(cardHeight)

  &:hover
    transform: translateY(-2px)
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12)

  // Compact small mode
  &.pa-1
    min-width: 50px
    max-width: 70px
</style>
